import React, { Component } from 'react';
import { connect } from 'react-redux';
import Service from '../../../services';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tooltip } from 'primereact/tooltip';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { BasicLazyParams } from '../../../utile';
import Authentication from './../../session';
import _ from 'lodash';
import { DownloadIconBulk, GradesIcon, MailIcon } from '../../svgIcons';
import LoadingComponent from '../../loadingComponent';
import { baseUrlAdmin } from './../../../store/apiConstants';
import './styles.scss';
import { getBulkUploadTransactionDetails, getBulkUploadTransactions, saveBulkUploadUsers, clearBulkUserUploadData } from './../../../store/actions';
import * as XLSX from 'xlsx';
import ClassetInputText from '../../../classetComponents/classetInputText';
import BranchToSectionDD from '../../BaseDropdownComponents/BranchToSectionDD';
import { getBoardsData, getBranchesLatest } from './../../../store/actions';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import moment from 'moment';

const SheetJSFT = ['xlsx', 'xlsb', 'xlsm', 'xls', 'csv']
    .map(function (x) {
        return '.' + x;
    })
    .join(',');

/* generate an array of column objects */
const make_cols = (refstr) => {
    let o = [],
        C = XLSX.utils.decode_range(refstr).e.c + 1;
    for (var i = 0; i < C; ++i) o[i] = { name: XLSX.utils.encode_col(i), key: i };
    return o;
};

const SampleBulkUplodData = [];

class UserBulkUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            openSnackBar: false,
            users: [],
            showMissedListTable: false,
            showUploadBtn: false,
            showLoader: false,
            transactionId: null,
            totalRecords: 0,
            globalSearch: '',
            lazyParams: BasicLazyParams,
            dropdownsData: {},
            admissionCategories: [],
            admissionCategoryId: null,
            admissionCategoryName: '',
            isShowDetails: false,
            columns: [{ columnName: 'Password', isVisible: false, id: 'password' }],
            refreshKey: 0
        };
        this.service = new Service();
    }

    refreshBranchToSectionDD = () => {
        this.setState((prevState) => ({
            refreshKey: prevState.refreshKey + 1
        }));
    };

    getBulkUploadTransactionsData = () => {
        console.log(this.state.lazyParams, 'this.state.lazyParams');
        this.props.getBulkUploadTransactions({ userId: this.props.userId }, { ...this.state.lazyParams, globalSearch: this.state.globalSearch });
    };

    componentDidMount = () => {
        this.getBulkUploadTransactionsData();
        this.getAdmissionTypeDropdown();
    };

    componentWillUnmount() {
        this.props.clearBulkUserUploadData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.error !== this.props.error) {
            if (this.props.error) {
                this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: 'Failed to upload bulk users data', life: 5000 });
            }
        }

        if (this.props && (this.props?.defaultDDValues !== undefined && this.props?.defaultDDValues !== null)) {
            const { admissionCategoryId } = this.props.defaultDDValues;
            this.setState({ admissionCategoryId: admissionCategoryId });
        }

        if (prevProps.bulkUserUploadSaveResponse !== this.props.bulkUserUploadSaveResponse) {
            if (this.props.bulkUserUploadSaveResponse) {
                const transactionId = this.props.bulkUserUploadSaveResponse?.transaction_id ? this.props.bulkUserUploadSaveResponse?.transaction_id : '';
                this.toast.show({ severity: 'success', summary: 'Process is initiated', detail: `Bulk users upload process initiated, kindly refer the transaction ${transactionId} details in below table`, life: 10000 });

                this.getBulkUploadTransactionsData();
            }
        }
        // console.log(this.props.bulkUserUploadRequested,"this.props.bulkUserUploadRequested")
        // if(this.props.bulkUserUploadRequested===true){
        //     this.getBulkUploadTransactionsData();
        //    // this.setDropdownValues({dropdownsData:{}})
        // }
    }

    handleFile = (file) => {
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        let data = [];
        reader.onload = (e) => {
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array' });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            let data = XLSX.utils.sheet_to_json(ws, { raw: true });
            this.setState({ data: data, cols: make_cols(ws['!ref']) });

            const newJsonSheet = [];
            for (let i = 0; i < data.length; i++) {
                let excelRowData = {
                    ...data[i],
                    __rowNum__: undefined
                };

                excelRowData = JSON.parse(JSON.stringify(excelRowData));

                newJsonSheet.push(excelRowData);
            }

            const users = newJsonSheet.map((record) => ({
                ...record,
                mobile: `${record.mobile ? '+91' + record.mobile : ''}`,
                admissionDate: record?.admissionDate
                    ? (typeof record.admissionDate === 'number' && !isNaN(record.admissionDate))
                        ? new Date(new Date(1899, 11, 30).getTime() + (record.admissionDate ? record.admissionDate * 86400000 : 0))
                        : moment(record.admissionDate, ['DD-MM-YYYY', 'DD/MM/YYYY'], true).isValid()
                            ? moment(record.admissionDate, ['DD-MM-YYYY', 'DD/MM/YYYY']).format('YYYY-MM-DDTHH:mm:ss.SSSZ')
                            : ''
                    : '',

                dateOfBirth: record?.dateOfBirth
                    ? (typeof record.dateOfBirth === 'number' && !isNaN(record.dateOfBirth))
                        ? new Date(new Date(1899, 11, 30).getTime() + (record.dateOfBirth ? record.dateOfBirth * 86400000 : 0))
                        : moment(record.dateOfBirth, ['DD-MM-YYYY', 'DD/MM/YYYY'], true).isValid()
                            ? moment(record.dateOfBirth, ['DD-MM-YYYY', 'DD/MM/YYYY']).format('YYYY-MM-DDTHH:mm:ss.SSSZ')
                            : ''
                    : '',

                prevAcademicDetailsPercentageOrGpa: record.prevAcademicDetailsPercentageOrGpa ? record.prevAcademicDetailsPercentageOrGpa * 100 : 0
            }));

            this.setState({ users });
        };
        if (rABS) reader.readAsBinaryString(file);
        else reader.readAsArrayBuffer(file);
    };
    convertToUTC = (inputDate) => {
        const parts = inputDate.split("/");
        const utcDate = new Date(Date.UTC(parts[2], parts[1] - 1, parts[0], 0, 0, 0));
        return utcDate.toISOString();
    }

    uploadBulkUsers = () => {

        let users = this.state.users.map((user) => {
            const trimmedUser = {};
            
            // Trim all string values and replace multiple spaces with single space
            Object.keys(user).forEach(key => {
                const value = user[key];
                if (typeof value === 'string') {
                    // Trim front and back, then replace multiple spaces with single space
                    trimmedUser[key] = value.trim().replace(/\s+/g, ' ');
                } else {
                    trimmedUser[key] = value;
                }
            });

            return {
                ...trimmedUser,
                dateOfBirth: trimmedUser.dateOfBirth,
                admissionDate: trimmedUser.admissionDate,
                board: this.state.dropdownsData?.selectedBoardName,
                boardId: this.state.dropdownsData?.boardId,
                grade: this.state.dropdownsData?.selectedClassName,
                gradeId: this.state.dropdownsData?.classId,
                sectionId: this.state.dropdownsData?.sectionId,
                sectionName: this.state.dropdownsData?.selectedsectionName,
                branchId: this.state.dropdownsData?.branchId,
                branchName: this.state.dropdownsData?.selectedbranchName,
                admissionCategoryId: this.state.admissionCategoryId,
                admissionCategoryName: this.state.admissionCategoryName,
            };
        });

        const payload = {
            user_id: this.props.userId,
            users: users,
            academicYear: localStorage && localStorage.getItem('userAcademicYear')
        };

        this.setState(
            {
                users: [],
                fileSelected: null,
                fileSelected: '',
                dropdownsData: {}
            },
            () => {
                this.props.saveBulkUploadUsers(payload);
                this.refreshBranchToSectionDD();
            }
        );
    };

    getTransactionDetails = (transactionId) => {
        this.setState(
            {
                isShowDetails: true,
                transactionId
            },
            () => {
                const payload = {
                    userId: this.props.userId,
                    transactionId
                };
                this.props.getBulkUploadTransactionDetails(payload);
            }
        );
    };

    onPage = (event) => {
        console.log(event, 'eventtt');
        this.setState((prevState) => {
            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.getBulkUploadTransactionsData);
    };

    onGlobalSearch = (e) => {
        this.setState((prevState) => {
            return {
                globalSearch: e.target.value,
                lazyParams: BasicLazyParams
            };
        }, this.getBulkUploadTransactionsData);
    };

    getAssignedStrength = async (sectionId) => {
        this.setState({
            isLoading: true
        });
        const academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/user/assignedStrength?sectionId=${sectionId}&academicYear=${academicYear}`;
        try {
            const res = await this.service.get(url, {}, true);
            if (res?.res?.status && res.status) {
                this.setState((prevState) => ({
                    dropdownsData: {
                        ...prevState.dropdownsData,
                        selectedSectionAssignedStudents: res?.res?.data?.assginedStrength,
                        maxStrength: res?.res?.data?.maxStrength
                    },
                    isLoading: false
                }));
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred', life: 3000 });
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }
    };

    setDropdownValues = (dropdownsData) => {
        this.setState(
            {
                dropdownsData: dropdownsData
            },
            () => { dropdownsData.sectionId && this.getAssignedStrength(dropdownsData.sectionId) }
        );
    };
    handleChange = (e) => {
        const files = e.target.files;
        if (files && files[0]) {
            this.setState({ fileSelected: files[0]['name'] });
            this.handleFile(files[0]);
            e.target.value = null;
        }
    };

    onChangeAdmissionCategory = (admissionCategoryId) => {
        let selectedAdmissionCategory = this.state.admissionCategories?.find((category) => category._id == admissionCategoryId)
        this.setState({
            admissionCategoryId: admissionCategoryId,
            admissionCategoryName: selectedAdmissionCategory?.categoryName
        });
    };
    exportCSV = () => {
        this.dt.exportCSV();
    };

    downloadSampleFile = () => {
        const filePath = `${process.env.PUBLIC_URL}/assets/student_bulk_upload_sample.xlsx`;

        fetch(filePath)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'student_bulk_upload_sample.xlsx');
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch(err => {
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Error downloading sample file', life: 3000 });
            });
    };

    exportCSV2 = () => {
        this.downloadSampleFile();
    };

    isColumnVisible = (id) => {
        return this.state.columns.filter((c) => c.id == id)[0].isVisible;
    };

    getAdmissionTypeDropdown = async () => {
        this.setState({
            isLoading: true
        });
        const academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admission-types/active?academicYear=${academicYear}`
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                // const result = res?.res?.data?.map(admission => ({
                //     label: admission.categoryName,
                //     value: admission._id
                // }));

                this.setState({ admissionCategories: res?.res?.data, isLoading: false });

            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred', life: 3000 });
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }

    };

    render() {
        console.log(this.state.dropdownsData, 'this.state.dropdownsData');
        const header = (
            <div className="flex justify-content-between bg-white">
                <div className="flex">
                    <h4 className="body-small-semibold">Students List</h4>
                    {this.state.showSearch && <InputText placeholder="Search" className="ml-4  h-2rem w-15rem" value={this.state.globalSearch} onChange={this.onGlobalSearch} />}
                </div>
            </div>
        );

        const header2 = (
            <div className="table-header ma-tbl-header ml-3 mr-3 mt -3 flex justify-content-between">
                <div className="">
                    <h4>Sample Bulk Upload Sheet</h4>
                </div>
                <div className="">
                    <ul className="ma-tbl-li">
                        <i data-pr-tooltip="Download" data-pr-position="bottom" className="pi pi-download ma-tbl-icon ma-tbl-dwnld" onClick={this.exportCSV2}></i>
                        <Tooltip className="table-li-tooltip" target=".ma-tbl-dwnld" />
                    </ul>
                </div>
            </div>
        );

        const headerTransaction = (
            <div className="table-header ma-tbl-header ml-3 mr-3 mt -3 flex justify-content-between">
                <div className="mt-4">
                    <h4>Transactions Details - {this.state.transactionId}</h4>
                </div>
                <div className="">
                    <ul className="ma-tbl-li">
                        <i data-pr-tooltip="Download" data-pr-position="bottom" className="pi pi-download ma-tbl-icon ma-tbl-dwnld" onClick={this.exportCSV}></i>
                        <Tooltip className="table-li-tooltip" target=".ma-tbl-dwnld" />
                    </ul>
                </div>
            </div>
        );
        return (
            <>
                <div>
                    <BranchToSectionDD setValues={this.setDropdownValues} key={this.state.refreshKey} />
                    <div className="col-3">
                        <ClassetDropdown required={true} label={'Admission Category'}
                            // icon={<GradesIcon />}
                            placeholder={'Select Category'}
                            value={this.state.admissionCategoryId} options={this.state.admissionCategories} onChange={(e) => this.onChangeAdmissionCategory(e.value)} optionLabel="categoryName"
                            optionValue="_id" />
                    </div>
                    <div class="">
                        <p className="body-small-semibold">Section strength : {this.state.dropdownsData?.selectedSectionMaxStrength
                            ? this.state.dropdownsData?.selectedSectionMaxStrength : '0'} Assigned students : {this.state.dropdownsData?.selectedSectionAssignedStudents
                                ? this.state.dropdownsData?.selectedSectionAssignedStudents : '0'}</p>
                    </div>

                    <div class="formgrid grid mx-4 my-4">
                        <div class="mr-2">
                            <ClassetInputText title="GradeName"
                                // icon={<MailIcon />}
                                placeholder={'File Name '} value={this.state.fileSelected} disabled />
                        </div>
                        <div class="mr-2 mt-3">
                            <label htmlFor="file" className="selectFile">
                                Select File
                            </label>
                            <input type="file" className="form-control" id="file" hidden={true} accept={SheetJSFT} onChange={this.handleChange} disabled={this.props.bulkUserUploadRequested} />
                        </div>
                        <div class="mr-2">
                            <Button
                                className="formUploadButton"
                                disabled={this.props.bulkUserUploadRequested}
                                onClick={() => {
                                    if (Object.keys(this.state.dropdownsData).length === 0) {
                                        this.toast.show({ severity: 'error', summary: `Branch,Board,Grade Selection is required. Please Select the all Dropdown  `, detail: '', life: 3000 });
                                        return;
                                    } else if (!Object.keys(this.state.dropdownsData).length === 8) {
                                        this.toast.show({ severity: 'error', summary: `Please Select the all Dropdown  `, detail: '', life: 3000 });
                                        return;
                                    } else if (this.state.fileSelected === undefined || this.state.fileSelected === '') {
                                        this.toast.show({ severity: 'error', summary: `Please Select the File  `, detail: '', life: 3000 });
                                        return;
                                    } else if (this.state.users.length > (this.state.dropdownsData?.selectedSectionMaxStrength - this.state.dropdownsData?.selectedSectionAssignedStudents)) {
                                        this.toast.show({ severity: 'error', summary: `Number of records in file exceeding section limit`, detail: '', life: 3000 });
                                        return;
                                    } else if (this.state.admissionCategoryId === null || this.state.admissionCategoryId === undefined || this.state.admissionCategoryId === '') {
                                        this.toast.show({ severity: 'error', summary: `Please select Admission Category`, detail: '', life: 3000 });
                                        return;
                                    } else if (this.state.users && this.state.users.length) {
                                        this.uploadBulkUsers();
                                    }
                                }}
                            >
                                <p className="formUploadButtonText">Upload Student Data</p>
                            </Button>
                        </div>

                        <div class="mr-2">
                            <Button
                                className="formBulkButton"
                                disabled={this.props.bulkUserUploadRequested}
                                onClick={() => {
                                    this.setState({
                                        isShowSampleFormat: true
                                    });
                                }}
                            >
                                <DownloadIconBulk /> <p className="formBulkButtonText">Download Bulk Format</p>
                            </Button>
                        </div>
                    </div>

                    <div className="card datatable-crud-demo mt-5 mx-4">
                        <DataTable
                            //  lazy
                            value={this.props.bulkUserUploadTransactions}
                            dataKey="id"
                            paginator
                            lazy
                            responsiveLayout="scroll"
                            className="dataTableValuesText"
                            showGridlines
                            columnResizeMode="expand"
                            resizableColumns
                            onPage={this.onPage}
                            first={this.state.lazyParams.first}
                            last={this.props.totalRecords}
                            rows={this.state.lazyParams.rows}
                            totalRecords={this.props.totalRecords}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            globalFilter={this.state.globalFilter}
                        >
                            <Column
                                style={{ width: '15rem', height: '6rem' }}
                                alignHeader={'center'}
                                sortable
                                headerClassName="text-color-secondary"
                                bodyClassName="text-center"
                                filterField="transaction_id"
                                field="transaction_id"
                                header="Transaction Id"
                            />
                            <Column style={{ width: '15rem', height: '6rem' }} alignHeader={'center'} sortable headerClassName="text-color-secondary" bodyClassName="text-center" filterField="bulkStatus" field="bulkStatus" header="Status" />

                            <Column
                                style={{ width: '15rem', height: '6rem' }}
                                alignHeader={'center'}
                                sortable
                                headerClassName="text-color-secondary"
                                bodyClassName="text-center"
                                filterField="uploadedAt"
                                field="uploadedAt"
                                header="Date"
                                body={(rowData) => {
                                    const date = new Date(rowData.uploadedAt);
                                    const formattedDate = date.toLocaleString(); // Format the date as desired
                                    return <p>{formattedDate}</p>;
                                }}
                            />

                            <Column
                                alignHeader={'center'}
                                sortable
                                headerClassName="text-color-secondary"
                                bodyClassName="text-center"
                                className=" "
                                header="Actions"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        // <Button label="Show Details" onClick={() => { }} className='p-button-outlined' />

                                        <Button
                                            className="formShowButton"
                                            disabled={this.props.bulkUserUploadRequested}
                                            // this.getTransactionDetails(rowData.transaction_id)
                                            onClick={() => this.getTransactionDetails(rowData.transaction_id)}
                                        >
                                            <p className="formShowButtonText">Show Details</p>
                                        </Button>
                                    );
                                }}
                            ></Column>
                        </DataTable>

                        <Dialog
                            draggable={false}
                            closeOnEscape={true}
                            className="ma-alert-box w-90"
                            blockScroll={true}
                            dismissableMask={false}
                            closable={true}
                            style={{ minHeight: '90vh' }}
                            visible={this.state.isShowSampleFormat}
                            onHide={() => this.setState({ isShowSampleFormat: false })}
                        >
                            <div>
                                <div className="card datatable-crud-demo ma-m30">
                                    <DataTable ref={(el) => (this.dt2 = el)} value={SampleBulkUplodData} dataKey="id" header={header2} emptyMessage="" scrollable responsiveLayout="scroll" style={{ width: '100%' }}>
                                        <Column field="firstName" header="firstName" />
                                        <Column field="lastName" header="lastName" />
                                        <Column field="username" header="username" />
                                        <Column field="email" header="email" />
                                        <Column field="password" header="password" />
                                        <Column field="gender" header="gender" />
                                        <Column field="admissionDate" header="admissionDate" />
                                        <Column field="aadharNo" header="aadharNo" />
                                        <Column field="dateOfBirth" header="dateOfBirth" />
                                        <Column field="contactPersonName" header="contactPersonName" />
                                        <Column field="parentContactNo" header="parentContactNo" />
                                        {/* <Column field="age" header="age" />
                                        <Column field="fatherName" header="fatherName" />
                                        <Column field="fatherOccupation" header="fatherOccupation" />
                                        <Column field="fatherQualification" header="fatherQualification" />
                                        <Column field="fatherMobileNum" header="fatherMobileNum" />
                                        <Column field="fatherEmailId" header="fatherEmailId" />
                                        <Column field="motherName" header="motherName" />
                                        <Column field="motherOccupation" header="motherOccupation" />
                                        <Column field="motherQualification" header="motherQualification" />
                                        <Column field="motherMobileNum" header="motherMobileNum" />
                                        <Column field="motherEmailId" header="motherEmailId" />
                                        <Column field="guardianName" header="guardianName" />
                                        <Column field="guardianOccupation" header="guardianOccupation" />
                                        <Column field="guardianQualification" header="guardianQualification" />
                                        <Column field="guardianMobileNum" header="guardianMobileNum" />
                                        <Column field="guardianEmailId" header="guardianEmailId" />
                                        <Column field="houseNum" header="houseNum" />
                                        <Column field="streetOrVillage" header="streetOrVillage" />
                                        <Column field="mandal" header="mandal" />
                                        <Column field="cityOrDist" header="cityOrDist" />
                                        <Column field="state" header="state" />
                                        <Column field="pinCode" header="pinCode" />
                                        <Column field="siblingsName" header="siblingsName" />
                                        <Column field="siblingsGender" header="siblingsGender" />
                                        <Column field="siblingsClassStudying" header="siblingsClassStudying" />
                                        <Column field="siblingsSchoolStudying" header="siblingsSchoolStudying" />
                                        <Column field="prevAcademicDetailsName" header="prevAcademicDetailsName" />
                                        <Column field="prevAcadamicDetailsClassStudied" header="prevAcadamicDetailsClassStudied" />
                                        <Column field="prevAcademicDetailsSchoolStudied" header="prevAcademicDetailsSchoolStudied" />
                                        <Column field="prevAcademicDetailsPercentageOrGpa" header="prevAcademicDetailsPercentageOrGpa" /> */}
                                    </DataTable>
                                </div>
                            </div>
                        </Dialog>

                        <Dialog
                            draggable={false}
                            closeOnEscape={true}
                            blockScroll={true}
                            dismissableMask={false}
                            closable={true}
                            style={{ minHeight: '90vh' }}
                            visible={this.state.isShowDetails}
                            onHide={() => this.setState({ isShowDetails: false })}
                            header={headerTransaction}
                        >
                            <div>
                                <div className="card datatable-crud-demo ma-m30">
                                    <DataTable
                                        ref={(el) => (this.dt = el)}
                                        //  lazy
                                        className="ma-alert-box w-100"
                                        value={this.props.bulkUserUploadTransactionDetails}
                                        dataKey="id"
                                        paginator
                                        rows={10}
                                        responsiveLayout="scroll"
                                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                        globalFilter={this.state.globalFilter}
                                    >
                                        <Column sortable field="username" header="User Name" />
                                        <Column sortable field="parentContactNo" header="Phone Number" />
                                        {this.isColumnVisible('password') && <Column sortable field="password" header="Password" />}
                                        <Column sortable field="isCreated" header="User Creation Status" />
                                        <Column sortable field="isError" header="Error Info" />
                                        <Column sortable field="board" header="Board" />
                                        <Column sortable field="grade" header="Class" />
                                        <Column sortable field="sectionName" header="Section" />
                                    </DataTable>
                                </div>
                            </div>
                        </Dialog>

                        {this.props.loading && <LoadingComponent />}
                        <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    loading: state.createNewUserInfo && state.createNewUserInfo.loading,
    error: state.createNewUserInfo && state.createNewUserInfo.error,
    bulkUserUploadTransactions: state.createNewUserInfo && state.createNewUserInfo.bulkUserUploadTransactions && state.createNewUserInfo.bulkUserUploadTransactions && state.createNewUserInfo.bulkUserUploadTransactions.bulkTransaction,
    totalRecords: state.createNewUserInfo && state.createNewUserInfo.bulkUserUploadTransactions && state.createNewUserInfo.bulkUserUploadTransactions && state.createNewUserInfo.bulkUserUploadTransactions.totalRecords,
    bulkUserUploadTransactionDetails:
        state.createNewUserInfo &&
        state.createNewUserInfo.bulkUserUploadTransactionDetails &&
        state.createNewUserInfo.bulkUserUploadTransactionDetails.bulkTransaction &&
        state.createNewUserInfo.bulkUserUploadTransactionDetails.bulkTransaction[0] &&
        state.createNewUserInfo.bulkUserUploadTransactionDetails.bulkTransaction[0].output_json,
    bulkUserUploadSaveResponse: state.createNewUserInfo && state.createNewUserInfo.bulkUserUploadSaveResponse && state.createNewUserInfo.bulkUserUploadSaveResponse,
    bulkUserUploadRequested: state.createNewUserInfo && state.createNewUserInfo.bulkUserUploadRequested && state.createNewUserInfo.bulkUserUploadRequested,

    userId: localStorage.getItem('username')
});

export default connect(mapStateToProps, {
    getBulkUploadTransactionDetails,
    getBulkUploadTransactions,
    saveBulkUploadUsers,
    clearBulkUserUploadData,
    getBoardsData,
    getBranchesLatest
})(Authentication(UserBulkUpload));
